import { render, staticRenderFns } from "./AdminAI.vue?vue&type=template&id=a3ab164e&scoped=true&"
import script from "./AdminAI.vue?vue&type=script&lang=js&"
export * from "./AdminAI.vue?vue&type=script&lang=js&"
import style0 from "./AdminAI.vue?vue&type=style&index=0&id=a3ab164e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ab164e",
  null
  
)

export default component.exports